const Scale = {
  Linear: "linear",
  Log: "log"
};
const CheckpointState = {
  Active: "ACTIVE",
  Completed: "COMPLETED",
  Deleted: "DELETED",
  Error: "ERROR",
  PartiallyDeleted: "PARTIALLY_DELETED",
  Unspecified: "UNSPECIFIED"
};
const DarkLight = {
  Dark: "dark",
  Light: "light"
};
const LogLevel = {
  Critical: "critical",
  Debug: "debug",
  Error: "error",
  Info: "info",
  None: "none",
  Trace: "trace",
  Warning: "warning"
};
const LogLevelFromApi = {
  Critical: "LOG_LEVEL_CRITICAL",
  Error: "LOG_LEVEL_ERROR",
  Warning: "LOG_LEVEL_WARNING",
  // eslint-disable-next-line sort-keys-fix/sort-keys-fix
  Info: "LOG_LEVEL_INFO",
  // eslint-disable-next-line sort-keys-fix/sort-keys-fix
  Debug: "LOG_LEVEL_DEBUG",
  Trace: "LOG_LEVEL_TRACE",
  Unspecified: "LOG_LEVEL_UNSPECIFIED"
};
const BrandingType = {
  Determined: "determined",
  HPE: "hpe"
};
const RunState = {
  Active: "ACTIVE",
  Canceled: "CANCELED",
  Completed: "COMPLETED",
  Deleted: "DELETED",
  DeleteFailed: "DELETE_FAILED",
  Deleting: "DELETING",
  Error: "ERROR",
  Paused: "PAUSED",
  Pulling: "PULLING",
  Queued: "QUEUED",
  Running: "RUNNING",
  Starting: "STARTING",
  StoppingCanceled: "STOPPING_CANCELED",
  StoppingCompleted: "STOPPING_COMPLETED",
  StoppingError: "STOPPING_ERROR",
  StoppingKilled: "STOPPING_KILLED",
  Unspecified: "UNSPECIFIED"
};
const CommandState = {
  Pulling: "PULLING",
  Queued: "QUEUED",
  Running: "RUNNING",
  Starting: "STARTING",
  Terminated: "TERMINATED",
  Terminating: "TERMINATING",
  Waiting: "WAITING"
};
const JobState = {
  QUEUED: "STATE_QUEUED",
  SCHEDULED: "STATE_SCHEDULED",
  SCHEDULEDBACKFILLED: "STATE_SCHEDULED_BACKFILLED",
  UNSPECIFIED: "STATE_UNSPECIFIED"
};
const ResourceState = {
  // This is almost CommandState
  Assigned: "ASSIGNED",
  Potential: "POTENTIAL",
  Pulling: "PULLING",
  Running: "RUNNING",
  Starting: "STARTING",
  Terminated: "TERMINATED",
  Unspecified: "UNSPECIFIED",
  Warm: "WARM"
};
const SlotState = {
  Free: "FREE",
  Pending: "PENDING",
  Potential: "POTENTIAL",
  Running: "RUNNING"
};
const WorkspaceState = {
  Deleted: "DELETED",
  DeleteFailed: "DELETE_FAILED",
  Deleting: "DELETING",
  Unspecified: "UNSPECIFIED"
};
const XAxisDomain = {
  Batches: "Batches",
  Epochs: "Epoch",
  Time: "Time"
};
export {
  BrandingType,
  CheckpointState,
  CommandState,
  DarkLight,
  JobState,
  LogLevel,
  LogLevelFromApi,
  ResourceState,
  RunState,
  Scale,
  SlotState,
  WorkspaceState,
  XAxisDomain
};
